/* eslint-disable camelcase */
import { useEffect } from "react";
import { loadScript } from "design-system/hooks/use-script";
import { useFetch } from "frontend/hooks/use-fetch";

export interface DisqusSSOProps {
  remoteAuthS3?: string;
  publicKey?: string;
}

// Extend the Window interface to include DISQUS
declare global {
  interface Window {
    DISQUS?: object;
    disqus_config?: () => void;
  }
}

export interface DisqusConfigPage {
  page: {
    url?: string;
    identifier?: string;
    title?: string;
    remote_auth_s3?: string;
    api_key?: string;
  };
}

export interface DisqusProps {
  shortName: string;
  config: {
    identifier: string;
    title: string;
    url: string;
  };
}

export function Disqus({ shortName, config }: DisqusProps) {
  if (
    !shortName ||
    shortName.length < 1 ||
    !config ||
    !config.identifier ||
    !config.title ||
    !config.url
  ) {
    return null;
  }

  const disqusConfig: DisqusConfigPage = {
    page: {
      url: config.url || "",
      identifier: config.identifier || "",
      title: config.title || "",
    },
  };

  const { data } = useFetch<DisqusSSOProps>({
    url: "/api/disqus",
  });

  useEffect(() => {
    // If the Disqus embed script has not been loaded, load it
    if (data) {
      if (!window.DISQUS) {
        // Set the disqus_config function
        window.disqus_config = function (this: DisqusConfigPage) {
          this.page.url = disqusConfig.page.url;
          this.page.identifier = disqusConfig.page.identifier;
          this.page.title = disqusConfig.page.title;
          this.page.remote_auth_s3 = data?.remoteAuthS3 || "";
          this.page.api_key = data?.publicKey || "";
        };

        loadScript(`https://${shortName}.disqus.com/embed.js`, { defer: true });
      }
    }
  }, [data]);

  return (
    <div className="disqus_thread_container" data-shortname={shortName}>
      <div id="disqus_thread"></div>
    </div>
  );
}
